var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpload = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 27,
  viewBox: "0 0 24 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.8919 1.18368C22.9569 1.19829 23.8074 2.0299 23.7952 3.04464C23.783 4.05937 22.9127 4.86739 21.8477 4.85278L2.59376 4.58874C1.52877 4.57413 0.678236 3.74252 0.690455 2.72779C0.702675 1.71305 1.57296 0.905037 2.63794 0.919642L21.8919 1.18368ZM10.8103 8.91011C11.571 8.2038 12.7924 8.22055 13.5359 8.94749L21.1491 16.3913C21.8926 17.1182 21.8786 18.282 21.1178 18.9883C20.3571 19.6946 19.1357 19.6779 18.3922 18.951L14.0265 14.6824L13.9031 24.9272C13.8909 25.9419 13.0206 26.7499 11.9556 26.7353C10.8907 26.7207 10.0401 25.8891 10.0523 24.8744L10.1757 14.6296L5.70865 18.777C4.94792 19.4833 3.72649 19.4666 2.98301 18.7396C2.23954 18.0127 2.25355 16.8489 3.01429 16.1426L10.8042 8.91002L10.8103 8.91011Z",
  fill: "#252525"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload.5aded5ca91dae46cfdbd91777da6024e.svg";